import { render, staticRenderFns } from "./TaxiForm.vue?vue&type=template&id=1491c806"
import script from "./TaxiForm.vue?vue&type=script&lang=js"
export * from "./TaxiForm.vue?vue&type=script&lang=js"
import style0 from "./TaxiForm.vue?vue&type=style&index=0&id=1491c806&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports